import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const getEmailReprotWithReportDetail = payload =>
  api.post(`/platform/reports`, payload.data, { params: payload.params })

const getSampleData = payload => api.get(`/platform/reports/preview`, { params: payload.params })

const getSampleCourseData = payload =>
  api.get(`/platform/reports/course/preview`, { params: payload.params })

const getCourseReportData = payload =>
  api.get(`/platform/reports/course/data`, { params: payload.params })

const getReportTrainingCamps = payload =>
  api.get(`/platform/report/training-camps`, { params: payload.params })

const getPhishCampaignReport = payload =>
  api.get(`/platform/reports/${payload.campaignId}`, { params: payload.params })

const getEmailTempLogReport = payload =>
  api.get(`/platform/reports/${payload.campaignId}/emailTemp`, { params: payload.params })

const getPhishEmailAction = payload =>
  api.get(`/platform/reports/${payload.campaignId}/actionGroup`, { params: payload.params })

const getCampaignHistory = payload =>
  api.get(`/platform/reports/${payload.campaignId}/history`, { params: payload.params })

const getUserPhishDepartment = payload =>
  api.get(`/platform/reports/${payload.campaignId}/dept`, { params: payload.params })

const getUserPhishOffice = payload =>
  api.get(`/platform/reports/${payload.campaignId}/office`, { params: payload.params })

const getTempResultReport = payload =>
  api.get(`/platform/reports/${payload.campaignId}/tempResult`, { params: payload.params })

const getOperatingSystemReport = payload =>
  api.get(`/platform/reports/${payload.campaignId}/osCount`, { params: payload.params })

const getUserPhishLogList = payload =>
  api.get(`/platform/reports/${payload.campaignId}/userLog`, { params: payload.params })

const getUserPhishLogTable = payload =>
  api.get(`/platform/reports/${payload.campaignId}/logTable`, { params: payload.params })

export default {
  getEmailReprotWithReportDetail,
  getSampleData,
  getSampleCourseData,
  getCourseReportData,
  getReportTrainingCamps,
  getPhishCampaignReport,
  getEmailTempLogReport,
  getPhishEmailAction,
  getCampaignHistory,
  getUserPhishDepartment,
  getUserPhishOffice,
  getTempResultReport,
  getOperatingSystemReport,
  getUserPhishLogList,
  getUserPhishLogTable,
}
